import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const ForgotPasswordModal = ({ onClose, onSubmit }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e?.preventDefault();
    
    if (!email) {
      setError('Email is required');
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/?.test(email)) {
      setError('Invalid email format');
      return;
    }

    setSubmitted(true);
    setTimeout(() => {
      onSubmit({ contactMethod: 'email', identifier: email });
    }, 2000);
  };

  return (
    <div className="fixed inset-0 z-[400] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative w-full max-w-md bg-card rounded-xl shadow-warm-2xl animate-scale-in p-6 md:p-8">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 rounded-lg hover:bg-muted transition-smooth"
        >
          <Icon name="X" size={20} />
        </button>

        {!submitted ? (
          <>
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-gradient-to-br from-warning to-accent rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="KeyRound" size={32} color="#FFFFFF" />
              </div>
              <h2 className="text-2xl font-heading font-semibold mb-2">Reset Password</h2>
              <p className="text-sm text-muted-foreground">
                Enter your email address to receive a password reset link
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <Input
                type="email"
                label="Email Address"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => {
                  setEmail(e?.target?.value);
                  setError('');
                }}
                error={error}
                required
              />

              <Button
                type="submit"
                variant="default"
                fullWidth
                iconName="Send"
                iconPosition="left"
              >
                Send Reset Link
              </Button>

              <div className="text-center">
                <button
                  type="button"
                  onClick={onClose}
                  className="text-sm text-muted-foreground hover:text-foreground transition-smooth"
                >
                  Back to login
                </button>
              </div>
            </form>
          </>
        ) : (
          <div className="text-center py-8">
            <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="CheckCircle" size={32} color="var(--color-success)" />
            </div>
            <h3 className="text-xl font-heading font-semibold mb-2">Check Your Email</h3>
            <p className="text-sm text-muted-foreground mb-6">
              We've sent a password reset link to
            </p>
            <p className="text-sm font-medium text-foreground mb-6">
              {email}
            </p>
            <Button
              variant="outline"
              fullWidth
              onClick={onClose}
            >
              Close
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordModal;